'use strict';

var debounce = require('lodash/debounce');

const mainHeader = {
    init: function () {
        const $window = $(window);
        const $body = $('body');
        const $expHeader = $('.experience-header');
        let lastScrollTop = $window.scrollTop();

        // Updating header and shop note height in css variables
        const $header = $('.experience-commerce_assets-mainHeader');

        let $searchResults = $('.search-results').first();
        let stickyOffset = 0;

        if ($searchResults.length) {
            stickyOffset = $searchResults.offset().top;

            $(document).on('shopnoteclose', function () {
                stickyOffset = $searchResults.offset().top;
            });

            $window.on('orientationchange', function () {
                stickyOffset = $searchResults.offset().top;
            });
        }

        // Detect scroll event
        $window.on(
            'scroll',
            debounce(function () {
                const currentScroll = $window.scrollTop();
                const headerHeight = $('.main-header-component').height() || 0;
                $expHeader.toggleClass('hide-header', $window.scrollTop() > $header.outerHeight() && !$('nav').hasClass('menu-active'));
                $('.minicart-overlay-wrapper').toggleClass('hide-header', $window.scrollTop() > $header.outerHeight());
                const isScrollDown = currentScroll > lastScrollTop;
                $body.toggleClass('scroll-up', !isScrollDown);
                lastScrollTop = currentScroll;
                if ($searchResults.length && !$body.hasClass('filter-open')) {
                    $body.toggleClass('sticky-filter-active', currentScroll >= stickyOffset - headerHeight && !$('.suggestions').length);
                }
            }, 50)
        );

        $window.on('load orientationchange', function () {
            // Updating header and shop note height in css variables
            const $topStrip = $('.experience-commerce_assets-shopNote');
            $body.css('--header-height', $header.height() + 'px');
            $body.css('--shop-note-height', $topStrip.is(':visible') ? $topStrip.height() + 'px' : '0px');
        });
    },
};

module.exports = mainHeader;
